import { DeleteOutlined } from '@ant-design/icons';
import { Button, Modal, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDeleteSavedSegment,
  useSavedSegments,
  useUpdateSavedSegment,
} from '../../../../api/Segments';

const { Text } = Typography;

function ManageSavedSegmentsModal({ visible, setVisible, surveyId }) {
  const { data: savedSegments, isLoading: savedSegmentsLoading } = useSavedSegments({ surveyId });
  const { mutate: deleteSavedSegment, isLoading: deleteSavedSegmentLoading } =
    useDeleteSavedSegment();
  const { mutate: updateSavedSegment } = useUpdateSavedSegment();

  const showConfirmDeleteModal = (segmentId) => {
    Modal.confirm({
      title: 'Are you sure?',
      autoFocusButton: 'ok',
      content:
        "This can't be undone. If you want this segment back, you'll need to create it again.",
      okText: 'Delete',
      onOk: () => deleteSavedSegment({ surveyId, segmentId }),
      okButtonProps: { danger: true, type: 'primary' },
    });
  };

  const columns = [
    {
      title: 'Label',
      dataIndex: 'label',
      render: (label, record) => (
        <Text
          editable={{
            onChange: (value) =>
              updateSavedSegment({
                surveyId,
                segmentId: record.id,
                data: { label: value },
              }),
          }}
        >
          {label}
        </Text>
      ),
    },
    {
      title: 'Values',
      dataIndex: 'segment',
      render: (values) => Object.values(values).flat().join(', '),
    },
    {
      key: 'delete',
      width: 30,
      render: (_, record) => (
        <Button
          icon={<DeleteOutlined />}
          type="link"
          onClick={() => showConfirmDeleteModal(record.id)}
        />
      ),
    },
  ];

  return (
    <Modal
      title="Manage saved segments"
      open={visible}
      onCancel={() => setVisible(false)}
      destroyOnClose
      maskClosable={false}
      footer={null}
      width={780}
    >
      <Table
        columns={columns}
        dataSource={savedSegments?.data}
        size="small"
        pagination={{
          hideOnSinglePage: true,
        }}
        loading={savedSegmentsLoading || deleteSavedSegmentLoading}
        rowKey="id"
      />
    </Modal>
  );
}

ManageSavedSegmentsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  surveyId: PropTypes.number.isRequired,
};

export default ManageSavedSegmentsModal;
